module.exports = __webpack_public_path__ + "static/img/baby_5.339e103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baby_5.png
// module id = W9Hj
// module chunks = 1